var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
export function ViewJobStickyHeaderWrapper(_a) {
    var takeFocus = _a.takeFocus, isStuck = _a.isStuck, children = _a.children;
    var rightPaneRef = useRef(null);
    useEffect(function () {
        var _a;
        if (takeFocus)
            (_a = rightPaneRef === null || rightPaneRef === void 0 ? void 0 : rightPaneRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [takeFocus]);
    return (_jsx(Box, __assign({ as: "header", tabIndex: 0, ref: rightPaneRef, className: isStuck ? "stuck" : "" }, { children: children })));
}
